export default "__VITE_ASSET__7t_2_uhV__"